let niveles = [
  {
    texto: "Todos",
    valor: ""
  },
  {
    texto: "Pre-Kinder",
    valor: "PREKINDER"
  },
  {
    texto: "Kinder",
    valor: "KINDER"
  },
  {
    texto: "1º Básico",
    valor: "PRIMERO_BASICO"
  },
  {
    texto: "2º Básico",
    valor: "SEGUNDO_BASICO"
  },
  {
    texto: "3º Básico",
    valor: "TERCERO_BASICO"
  },
  {
    texto: "4º Básico",
    valor: "CUARTO_BASICO"
  },
  {
    texto: "5º Básico",
    valor: "QUINTO_BASICO"
  },
  {
    texto: "6º Básico",
    valor: "SEXTO_BASICO"
  },
  {
    texto: "7º Básico",
    valor: "SEPTIMO_BASICO"
  },
  {
    texto: "8º Básico",
    valor: "OCTAVO_BASICO"
  },
  {
    texto: "I Medio",
    valor: "PRIMERO_MEDIO"
  },
  {
    texto: "II Medio",
    valor: "SEGUNDO_MEDIO"
  },
  {
    texto: "III Medio",
    valor: "TERCERO_MEDIO"
  },
  {
    texto: "IV Medio",
    valor: "CUARTO_MEDIO"
  }
];

let getNiveles = function() {
  return niveles;
};

export default {
  getNiveles
};



// WEBPACK FOOTER //
// ./src/utils/Niveles.js